export default "__VITE_ASSET__CHDfIKuq__"